import React, { useState } from "react";
import Slider from "rc-slider";
import { useIntl } from "react-intl";
import { TRAVEL_DISTANCE } from "~src/constants";

import "./style.scss";

const DistanceRangeSlider = ({
  min = TRAVEL_DISTANCE.min,
  max = TRAVEL_DISTANCE.max,
  step = 1,
  defaultValue,
  onChange = () => {},
}) => {
  const finalDefaultValue = defaultValue === 0 || defaultValue === undefined ? max : defaultValue;
  const intl = useIntl();
  const [value, setValue] = useState(finalDefaultValue);

  return (
    <div className="teal-slider-wrapper teal-slider-wrapper--distance">
      <h4>
        {intl.formatMessage({
          id: 'containers.customers.filters.distance.label',
          defaultMessage: 'Maximum distance',
        })}
      </h4>
      <div className="c-price-labels">
        <div className="c-label-wrap">
          <div className="c-pric-label">
            {intl.formatMessage({
              id: 'containers.customers.filters.distance.minimum',
              defaultMessage: 'Minimum',
            })}
          </div>
          <div className="c-label">{min} km</div>
        </div>
        <div className="c-label-wrap">
          <div className="c-pric-label">
            {intl.formatMessage({
              id: 'containers.customers.filters.distance.maximum',
              defaultMessage: 'Maximum',
            })}
          </div>
          <div className="c-label">{value} km</div>
        </div>
      </div>

      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={setValue}
        onChangeComplete={(val) => onChange(val)}
        trackStyle={[
          { backgroundColor: "#23AFB3", height: 2 },
        ]}
        handleStyle={[
          {
            borderColor: "#dddddd",
            backgroundColor: "#fff",
            opacity: 1,
            borderWidth: 1,
            height: 27,
            width: 27,
            marginTop: -13,
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          },
        ]}
        railStyle={{ backgroundColor: "#eee", height: 2 }}
      />
    </div>
  );
};

export default DistanceRangeSlider;
